import {IconButton, Stack, TextField, TextFieldProps, Tooltip} from '@mui/material';
import {Info} from '@mui/icons-material';
import MarkdownContentRenderer from '../MarkdownContentRenderer/MarkdownContentRenderer';

export interface TextWithRendererProps extends Omit<TextFieldProps, 'value'> {
  /** The value of the text field */
  value: string;
  /** show the render in a tooltip */
  tooltipRender?: boolean;
}

export default function TextWithRenderer({
  tooltipRender,
  value,
  fullWidth,
  sx,
  ...textFieldProps
}: TextWithRendererProps) {
  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      sx={{width: fullWidth ? '100%' : 'auto'}}
      data-testid="text-with-renderer"
    >
      <TextField value={value} fullWidth={fullWidth} {...textFieldProps} sx={{flex: fullWidth ? 1 : 'none', ...sx}} />
      {tooltipRender && (
        <Tooltip title={<MarkdownContentRenderer content={value || ''} />} arrow placement="top">
          <IconButton size="small" color="primary">
            <Info fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
    </Stack>
  );
}
